export class RoutingPath {

	static readonly PATH_EMPTY = '';
	static readonly PATH_404 = '404';
	static readonly PATH_ANY = '**';

	// Login
	static readonly PATH_LOGIN = 'login';

	// Cloud
	static readonly PATH_CLOUD = 'cloud';

	// Home
	static readonly PATH_HOME = 'home';

	// Statistics
	static readonly PATH_STATISTICS = 'statistics';
	static readonly PATH_STATISTICS_WITH_PARAMETER = 'statistics/:id';
	static readonly PATH_STATISTICS_LOGS = 'statistics/logs/:idJob/:dgeId';

	// Monitoring
	static readonly PATH_MONITORING = 'monitoring';

	// Configuration
	static readonly PATH_CONFIGURATION = 'configuration';
	static readonly PATH_GENERAL = 'general';
	static readonly PATH_SERVICES = 'services';
	static readonly PATH_ALERT_RULES = 'alert-rules';
	static readonly PATH_ALIAS = 'alias';
	static readonly PATH_FAILED_JOBS = 'failed-jobs';
	static readonly PATH_ENGINES = 'engines';
	static readonly PATH_SELF_MAINTENANCE = 'self-maintenance';
}